var script_loaded = !1; 
function loadJSscripts() { 
  if (script_loaded) return;

  // Safely skip uLTS if not defined
  if (typeof uLTS !== 'undefined') {
    try {
      uLTS.disconnect();
    } catch(e) {
      console.warn('uLTS disconnect failed:', e);
    }
  }

  // Safely skip yett if not defined
  if (typeof window.yett !== 'undefined') {
    try {
      window.yett.unblock();
    } catch(e) {
      console.warn('Yett unblock failed:', e);
    }
  }

  script_loaded = !0;

  document.querySelectorAll("iframe[data-src], script[data-src]").forEach((a) => { 
    let datasrc = a.dataset.src;
    if (datasrc) {
      a.src = datasrc; 
    }
  });

  document.querySelectorAll("link[data-href]").forEach((a) => { 
    let datahref = a.dataset.href;
    if (datahref) {
      a.href = datahref; 
    }
  });

  document.querySelectorAll("script[type='text/lazyload']").forEach((d) => { 
    var b = document.createElement("script"); 
    for (let a = 0; a < d.attributes.length; a++) { 
      var c = d.attributes[a]; 
      b.setAttribute(c.name, c.value); 
    } 
    b.type = "text/javascript"; 
    b.innerHTML = d.innerHTML; 
    d.parentNode.insertBefore(b, d); 
    d.parentNode.removeChild(d); 
  });

  document.dispatchEvent(new CustomEvent("asyncLazyLoad"));
  
  setTimeout(function () { 
    document.dispatchEvent(new CustomEvent("loadBarInjector")); 
  }, 3000); 
} 

var activityEvents = [ 
  "mousedown", "mousemove", "keydown", "scroll", 
  "touchstart", "click", "keypress", "touchmove" 
]; 

activityEvents.forEach(function (a) { 
  window.addEventListener(a, loadJSscripts, !1); 
});

// Immediate first load in case no user interaction occurs
document.addEventListener('DOMContentLoaded', loadJSscripts);